<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    dark
    flat
    height="75"
    :src="barImage"
  >
    <template v-slot:img="{ props }">
      <v-img
        v-bind="props"
        :gradient="`to bottom, ${barColor}`"
      />
    </template>
    <v-btn
      class="mr-3"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    />

    <v-spacer />
    <div class="mx-3" />

    <v-btn
      class="ml-2"
      min-width="0"
      text
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>
    <!-- Notifications -->
    <v-menu
      v-model="showMenu"
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          @click="open"
        >
          <v-badge
            v-if="notifications.length > 0"
            color="red"
            overlap
            bordered
          >
            <template
              v-slot:badge
            >
              <span>{{ notifications.length }}</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
          <v-icon v-else>
            mdi-bell
          </v-icon>
        </v-btn>
      </template>

      <v-list
        two-line
        :tile="false"
        nav
      >
        <div v-if="notifications.length > 0">
          <template v-for="(item, i) in notifications">
            <v-list-item :key="`item-${i}`">
              <!--<template v-slot:default="{ active, toggle }">-->
              <template>
                <v-list-item-content @click="goNotifications">
                  <v-list-item-title v-text="item.title" />
                  <!--<v-list-item-subtitle class="text&#45;&#45;primary" v-text="item.headline"></v-list-item-subtitle>-->
                  <v-list-item-subtitle v-text="item.description" />
                </v-list-item-content>

                <v-list-item-action>
                  <!--<v-list-item-action-text v-text="timeFrom(item.created)" />-->
                  <!--<v-icon-->
                  <!--v-if="!active"-->
                  <!--color="grey lighten-1"-->
                  <!--&gt;-->
                  <!--star_border-->
                  <!--</v-icon>-->
                  <!--<v-icon-->
                  <!--v-else-->
                  <!--color="yellow"-->
                  <!--&gt;-->
                  <!--star-->
                  <!--</v-icon>-->
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </div>
        <div v-else>
          <template>
            <v-list-item :key="`item-${i}`">
              <template>
                <v-list-item-content @click="goNotifications">
                  <v-list-item-title v-text="'No notificaciones nuevas'" />
                </v-list-item-content>
                <v-list-item-action />
              </template>
            </v-list-item>
          </template>
        </div>
      </v-list>
    </v-menu>

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <template
          v-for="(p, i) in profile"
        >
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <app-bar-item
            v-else
            :key="`item-${i}`"
            :to="p.logout ? '' : '/dashboard/profile'"
          >
            <v-list-item-title
              @click="p.logout ? logout() : to "
              v-text="p.title"
            />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import { auth } from '@/plugins/auth/firebase'
  import Cookie from 'js-cookie'
  import loaders from '@/plugins/mixins/loaders'
  import Vue from 'vue'
  // Utilities
  export default {
    name: 'DashboardCoreAppBar',
    filters: {
      timeFrom: function (date) {
        return Vue.moment(date).fromNow()
      },
    },
    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },
    mixins: [loaders],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({

      profile: [
        { title: 'Mi perfil', to: 'dashboard/profile' },
        { divider: true },
        { logout: true, title: 'Cerrar sesión' },
      ],
    }),

    computed: {
      notifications () {
        return this.$store.getters['notifications/getNoRead']
      },
      barImage () {
        return this.$store.state.drawer.barImage
      },
      barColor () {
        return this.$store.state.drawer.barColor
      },
      drawer () {
        return this.$store.state.drawer.drawer
      },
    },
    created () {
      const vm = this
      vm.loadNoRead()
    },

    methods: {
      open () {
        const vm = this
        if (vm.notifications.length > 0 && vm.showMenu) {
          // Actualizar
          vm.$store.dispatch('notifications/UpdateNoRead')
        }
      },
      goNotifications () {
        if (this.notifications.length > 0) {
          // Actualizar
          // console.log('actualizar')
          this.$store.dispatch('notifications/UpdateNoRead')
          this.$router.replace('notifications')
        }
      },
      async logout () {
        const vm = this
        // console.log('logout')
        await auth.signOut()
        await Cookie.remove('access_token')
        vm.$store.dispatch('users/clearUser').then(function () {
          vm.$router.push('/pages/login').catch(err => {
            console.log(err)
          })
        })
      },
      setDrawer (payload) {
        this.$store.dispatch('drawer/set_drawer', payload)
      },

    },
  }
</script>
